<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Syarat dan Ketentuan</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div>
                <div class="section mt-2" v-if="tos_data">
                    <div class="mb-3">
                        <h3>Syarat & Kententuan {{ tos_data.name }}</h3>
                    </div>
                    <div
                        class="text-justify"
                        style="font-size: 12px; line-height: 150%"
                    >
                        <div
                            v-html="tos_data.tos_version_published.content"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: false,
            };
        },
        created() {
            this.loadingApp = true;
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('tos', {
                tos_data: state => state.tos_data,
                loading: state => state.loading,
            }),
        },
        methods: {
            ...mapActions('tos', ['getTosDetail']),
            ...mapMutations('tos', []),
        },

        mounted() {
            this.getTosDetail(this.$route.params.id).then(() => {
                this.loadingApp = false;
                if (!this.tos_data) {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message:
                            'Terjadi kesalahan, tidak dapat menampilkan data',
                        tipe: 'default',
                        icon: 'danger',
                    });
                    this.$router.go(-1);
                }
            });
        },
        destroyed() {},
    };
</script>
